import { useEffect } from "react";
import { createPortal } from "react-dom";
import { getAppPortalRoot } from "../utils/appPortal";
import "./LibraryImportNotice.css";

const LIBRARY_BOOK_ALREADY_PRESENT = "Ce livre est déjà présent dans votre bibliothèque";

export default function LibraryImportNotice({
  open = false,
  title = "",
  ok = false,
  duplicate = false,
  detail = "",
  onClose = () => {},
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => {
      if (event.key === "Escape" || event.key === "Enter") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const name = String(title || "Ce livre").trim() || "Ce livre";
  const reason = String(detail || "").trim();
  const message = duplicate
    ? LIBRARY_BOOK_ALREADY_PRESENT
    : ok
      ? `${name} a été ajouté à votre bibliothèque`
      : `Une erreur est survenue: ${name} n'a pas été ajouté à votre bibliothèque`;

  return createPortal(
    <div className="library-import-notice-backdrop" role="presentation">
      <div
        className="library-import-notice"
        role="dialog"
        aria-modal="true"
        aria-labelledby="library-import-notice-text"
      >
        <p id="library-import-notice-text" className="library-import-notice__text">
          {message}
          {!ok && !duplicate && reason ? (
            <span className="library-import-notice__detail">{reason}</span>
          ) : null}
        </p>
        <button type="button" className="library-import-notice__ok" onClick={onClose}>
          OK
        </button>
      </div>
    </div>,
    getAppPortalRoot()
  );
}
